import { apiInstance } from "../instances/apiInstance"
import { Menu } from "../../models/menu"

export default {
    mainMenu: (): Promise<Menu> => apiInstance.get("/menu").then(response => response.data)
}
